module.exports = __webpack_public_path__ + "static/media/• Proposa.2d5426c7.webp";